export const PAGE_SIZE = 20;
export const ORDER_OPTIONS = [
  {
    label: '默认排序',
    value: 'default',
  },
  {
    label: '收益最高',
    value: 'estIncome',
  },
  {
    label: '奖励最高',
    value: 'estReward',
  },
  {
    label: '最近绑定',
    value: 'btime',
  },
  {
    label: '昨日达标优先',
    value: 'yMeet',
  },
  {
    label: '昨日未达标优先',
    value: 'yNotMeet',
  },
];
export const REWARD_MEET_STATUS = {
  '1': 'meet',
  '0': 'notmeet',
  '-1': 'finish',
};

export const REWARD_FAIL_STATUS = 'notmeet';

export const REWARD_RULE_LINK_MAP = {};

export const TIME_FORMAT = 'YYYY-MM';
export const TIME_PICKER_FORMAT = 'YYYY-MM';
export const DEFAULT_TEXT = '--';

export const DEFAULT_TYPE = {
  label: '奖励类型',
  value: 'all',
};

export const QUARTER_TIME_MAP = {
  0: '首月',
  1: '连续2月',
  2: '连续3月',
};

// 默认日历信息
export const DEFAULT_CALENDAR_ITEM = {
  timeid: '19700101',
  meetState: 'nojoin',
};

export const FIXED_MIN_MONTH = '2021-10';
